import(/* webpackMode: "eager", webpackExports: ["ResearchCTA"] */ "/vercel/path0/components/cta/ResearchCTA.tsx");
